import { createContext } from 'react';

const RecipeInProgressContext = createContext();

export default RecipeInProgressContext;
